<div [ngClass]="bannerCustomClass">
  <div class="banner-content">
    <fa-icon *ngIf="showBannerIcon" class="banner-icon" [icon]="['fas', bannerIcon]"></fa-icon>
    <ng-content></ng-content>
  </div>
</div>
